const isLocal = location.hostname === "localhost";

export const endpoints = {
  newsFeed: isLocal
    ? "/api/news-feed-render.php"
    : "/student-zone-26/assets/public/api/news-feed-render.php",
  eventsFeed: isLocal
    ? "/api/events-feed-render.php"
    : "/student-zone-26/assets/public/api/events-feed-render.php",
};
